import React from "react";
import "./src/styles/global.css";
import "./src/styles.scss";
import { I18nextProvider } from "react-i18next";
import { createI18nInstance } from "./src/utils/createI18nInstance";

export const wrapPageElement = ({ element, props }) => {
  const lang = props.pageContext.lang || props.pageContext.language || 'en';
  const translations = props.pageContext.translations;

  let i18n;
  if (translations) {
    i18n = createI18nInstance(lang, translations);
  } else {
    // Fallback for 404 or pages without translations in pageContext
    const i18next = require('i18next');
    i18n = i18next.createInstance();
    i18n.init({
      resources: {},
      lng: 'en',
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
      initImmediate: false,
    });
  }

  return <I18nextProvider i18n={i18n}>{element}</I18nextProvider>;
};
